import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useCanShowCoupons} from '../../../../../features/Coupons/useCanShowCoupons';
import {useProminentBannerSection} from '../../../useGetProductBulkSection';
import {CouponHintView} from './CouponHintView';

export const CouponHint: React.FC<{productId: number}> = props => {
  const request = useProminentBannerSection();
  const canShowCoupons = useCanShowCoupons();

  if (!canShowCoupons) {
    return null;
  }

  return (
    <DataFetcher
      request={request}
      Error={null}
      viewProps={props}
      View={viewProps => (
        <CouponHintView {...viewProps} isInMiniADPDialog={false} />
      )}
    />
  );
};
